//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AnimationDesigner.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/SelectNXObjectList.js";
import "../no/Expression.js";
import "../no/SelectObjectList.js";
let d=[[[0,"AngularVelocityDirection",1,"Direction",0],[1,"AngularVelocityMagnitude",0,"Expression",0],[0,"Color",1,0],[0,"ColorOption",1,0],[0,"CreationType",1,0],[1,"Geometry",0,"SelectNXObjectList",0],[1,"InertiaIxx",0,"Expression",0],[1,"InertiaIxy",0,"Expression",0],[1,"InertiaIxz",0,"Expression",0],[1,"InertiaIyy",0,"Expression",0],[1,"InertiaIyz",0,"Expression",0],[1,"InertiaIzz",0,"Expression",0],[0,"LinearVelocityDirection",1,"Direction",0],[1,"LinearVelocityMagnitude",0,"Expression",0],[1,"Mass",0,"Expression",0],[0,"MassCenterPoint",1,"Point",0],[0,"MassProperty",1,0],[0,"Name",1,0],[0,"Orientation",1,"CoordinateSystem",0]],[],[]];
SPLM.AnimationDesigner.RigidGroupBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AnimationDesigner.RigidGroupBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.AnimationDesigner.RigidGroupBuilder.MassPropertiesOption = Object.freeze({
    "Automatic" : "Automatic", "UserDefined" : "UserDefined"});

SPLM.AnimationDesigner.RigidGroupBuilder.CreationTypes = Object.freeze({
    "Combine" : "Combine", "Separate" : "Separate"});

SPLM.AnimationDesigner.RigidGroupBuilder.ColorOptions = Object.freeze({
    "SpecifyColor" : "SpecifyColor", "AutomaticColor" : "AutomaticColor", "NoColor" : "NoColor"});

export default SPLM;